/* unplugin-vue-components disabled */import { render } from "./FooterForMobile.vue?vue&type=template&id=1ac867d4&scoped=true"
import script from "./FooterForMobile.vue?vue&type=script&lang=js"
export * from "./FooterForMobile.vue?vue&type=script&lang=js"

import "./FooterForMobile.vue?vue&type=style&index=0&id=1ac867d4&lang=less&scoped=true"

import exportComponent from "/root/workspace/coottlVideoPage_JjFl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac867d4"]])

export default __exports__